import User, { IUserAPIModel } from '../models/user-profile/User';
import Http from './Http';
import BaseAPI from './BaseAPI';
import InkindPage, { IUserPageAPIModel } from '../models/inkinds/InkindPage';
import Organizer from '@/app/models/inkind-organizers/Organizer';

export default class UserProfileAPI extends BaseAPI {
  public async getPage(routeId: string): Promise<InkindPage> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}`);
    const apiResponse: Response = await Http.get({ url });
    return InkindPage.fromAPI(Object.assign({}, (await apiResponse.json()) as IUserPageAPIModel, { routeId }));
  }

  public async getUserDetails(userId: string): Promise<User> {
    const url: string = this.buildAPIEndPoint(`/users/${userId}`);
    const apiResponse: Response = await Http.get({ url });
    return User.fromAPI(Object.assign({}, { id: userId }, (await apiResponse.json()) as IUserAPIModel));
  }

  public async updateUserLastSeenWelcomeScreen(user: User): Promise<void> {
    const url: string = this.buildAPIEndPoint(`/users/${user.getId()}/welcomeScreenLastSeen`);
    await Http.put({ url });
  }

  public async submitSurveyResults(user: User, foundOutAboutGIK: string): Promise<User> {
    const url: string = this.buildAPIEndPoint(`/users/${user.getId()}/feedback`);
    Http.post({ url, body: JSON.stringify({ feedback: foundOutAboutGIK }) });
    return Object.assign({}, user, { foundOutAboutGIK });
  }

  public async getPagePendingInvitees(routeId: string): Promise<Organizer[]> {
    const url: string = this.buildAPIEndPoint(`/inkinds/${routeId}/pendingInvitations`);
    const apiResponse: Response = await Http.get({ url });
    return await apiResponse.json() as Organizer[];
  }
}
